import { cx } from '@linaria/core';
import { radioButtonMediaInput } from '@utils/component-framework';
import { useOpgavekompleksetEntry } from '../../../../state/hook.entry.js';
import { useUpdateTaskEntryMutation } from '../../../../state/mutations/update-task-entry.js';
import { CircledAudioPlayer } from '../../../atom.audio/_audio-player.circled.js';
import { useTaskContext } from '../../context.js';
import { useInputState } from '../../hook.use-input-state.js';
import { TextBox } from '../atom.text-box/_text-box.js';
import { wrapper, box, audio } from './input.text.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function TextInput(props) {
  const context = useTaskContext();
  const update = useUpdateTaskEntryMutation();
  const inputEntry = useOpgavekompleksetEntry({
    select: entry => radioButtonMediaInput.entry.asType(entry?.data.tasks[props.taskEntryKey]?.details[props.node.id])
  });
  const onChange = () => {
    update(props.taskEntryKey, prev => {
      const next = Object.fromEntries(Object.entries(prev ?? {}).filter(([, value]) => value.type !== "radio-button-media" || value.taskId !== props.taskId));
      return {
        ...next,
        [props.node.id]: {
          type: "radio-button-media",
          taskId: props.taskId,
          markedAsCorrectAnswer: !inputEntry?.markedAsCorrectAnswer
        }
      };
    });
  };
  const baseState = useInputState(props.node, inputEntry, {
    forceValidation: (node, entry) => !!entry?.markedAsCorrectAnswer
  });
  const state = (() => {
    if (baseState === "incorrect" && !inputEntry?.markedAsCorrectAnswer && props.node.correctAnswer) {
      return "should-have";
    }
    return baseState;
  })();
  return /*#__PURE__*/jsxs("div", {
    className: wrapper,
    children: [/*#__PURE__*/jsx(TextBox, {
      className: cx(box, props.node.audioSrc && "hasAudio"),
      checked: !!inputEntry?.markedAsCorrectAnswer,
      state: state,
      onChange: onChange,
      orientation: props.orientation,
      theme: "rounded",
      children: /*#__PURE__*/jsx("span", {
        children: props.node.text
      })
    }), props.node.audioSrc && /*#__PURE__*/jsx(CircledAudioPlayer, {
      className: cx(audio, context === "facit" && state === "readonly" && "readonly"),
      src: props.node.audioSrc,
      size: "small"
    })]
  });
}

export { TextInput };
//# sourceMappingURL=input.text.js.map
